import { AutocompleteRenderInputParams, Box, TextField } from '@mui/material';
import { SxProps, Theme } from '@mui/system';
import { Controller, Control, FieldErrors } from 'react-hook-form';
import { HTMLAttributes } from 'react';
import { Country, getCountries } from './countries';

import { StyledPaper, StyledAutocomplete } from './styles';

export interface CountryInputsInterface {
  countryPhoneCode: string;
}

interface CountryAutoCompleteProps {
  valueDDI: string;
  setValueDDI: (ddi: string, country: Country | null) => void;
  sx?: SxProps<Theme>;
  dropBoxWidth?: string;
  control: Control<CountryInputsInterface, any>;
  errors: FieldErrors<CountryInputsInterface>;
  disabeld?: boolean;
}

const CountryAutoComplete = ({
  valueDDI,
  setValueDDI,
  sx,
  dropBoxWidth,
  control,
  errors,
  disabeld,
}: CountryAutoCompleteProps) => {
  const countries = getCountries();
  const previousCountry =
    countries.find((option) => option.value === valueDDI) || null;

  const renderInput = (params: AutocompleteRenderInputParams) => {
    return (
      <TextField
        {...params}
        color="focus"
        placeholder="+1"
        disabled={disabeld}
        error={!!errors.countryPhoneCode}
        helperText={errors.countryPhoneCode?.message}
        slotProps={{
          htmlInput: {
            ...params.inputProps,
            autoComplete: 'new-password',
            sx: {
              textAlign: 'center',
            },
          },
        }}
      />
    );
  };

  const renderList = (
    props: HTMLAttributes<HTMLLIElement> & {
      key: string;
    },
    option: Country
  ) => {
    const { key, ...optionProps } = props;
    return (
      <Box
        component="li"
        key={option.flag + option.country + option.label}
        {...optionProps}
      >
        {option.flag} {option.country} ({option.label})
      </Box>
    );
  };

  return (
    <Controller
      name={'countryPhoneCode'}
      control={control}
      defaultValue={valueDDI}
      render={({ field }) => (
        <StyledAutocomplete
          id="country-select-demo"
          sx={sx}
          options={countries}
          autoHighlight
          value={previousCountry}
          getOptionLabel={(option) => {
            if (typeof option === 'string') {
              return previousCountry?.label ?? '';
            }
            try {
              const countryOption = option as Country;
              return countryOption.label;
            } catch {
              return '';
            }
          }}
          renderOption={(props, option) => {
            const country = option as Country;
            return renderList(props, country);
          }}
          renderInput={renderInput}
          onChange={(_, newOption) => {
            const countryOption = newOption as Country;
            field.onChange(newOption ? countryOption.value : '');
            setValueDDI(
              newOption ? countryOption.value : '',
              newOption ? countryOption : null
            );
          }}
          slots={{
            paper: (props) => (
              <StyledPaper {...props} dropboxwidth={dropBoxWidth} />
            ),
          }}
        />
      )}
    />
  );
};

export default CountryAutoComplete;
